module.exports = __webpack_public_path__ + "static/media/evolution.6f8f90c.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/evolution.mp4
// module id = D17P
// module chunks = 1